// extracted by mini-css-extract-plugin
module.exports = {"icomoon-font":"MobileMenuTrigger_icomoon-font__jgwVY","MobileMenuIcon":"MobileMenuTrigger_MobileMenuIcon__n5wVZ"};